<template>
  <b-card
    v-if="payment"
    no-body
    class="card-statistics"
  >
    <b-card-header>
      <b-card-title>{{ $t('Payment') }} {{ payment.id }}</b-card-title>
    </b-card-header>
    <b-card-body class="statistics-body">
      <b-row>
        <b-col
          v-for="item in statistics"
          :key="item.icon"
          xl="3"
          sm="6"
          :class="item.customClass"
        >
          <b-media no-body>
            <b-media-aside

              class="mr-2"
            >
              <b-avatar
                size="48"
                :variant="item.color"
              >
                <feather-icon
                  size="24"
                  :icon="item.icon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h5 class="font-weight-bolder mb-0">
                {{ item.title }}
              </h5>
              <b-card-text class="font-small-3 mb-0">
                {{ item.subtitle }}
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardText, BCardBody, BRow, BCol, BMedia, BMediaAside, BAvatar, BMediaBody,
} from 'bootstrap-vue'
import { localeDateTime } from '../../../common/utils/utils'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
  },
  props: {
    payment: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {

    }
  },
  computed: {
    statistics() {
      const data = [
        {
          title: this.payment.display_payable_label,
          subtitle: this.$t('Pay for'),
          icon: 'BoxIcon',
          color: 'light-danger',
          customClass: '',
        },
        {
          title: this.payment.display_status,
          subtitle: this.$t('Status'),
          icon: 'ActivityIcon',
          color: this.payment.is_paid ? 'light-success' : 'light-danger',
          customClass: '',
        },
        {
          title: localeDateTime(this.payment.created_at),
          subtitle: this.$t('Created at'),
          icon: 'CalendarIcon',
          color: 'light-warning',
          customClass: '',
        },
      ]
      if (this.payment.is_paid) {
        data.push({
          title: localeDateTime(this.payment.payment_at),
          subtitle: this.$t('Payment at'),
          icon: 'ClockIcon',
          color: 'light-info',
          customClass: '',
        })
      }
      return data
    },
  },
}
</script>
